module.exports = __webpack_public_path__ + "static/media/8OLA28.7946ad20.jpg";